import { IonButton, useIonModal } from "@ionic/react";
import { Lobby } from "../types/lobby";
import LobbySummary from "../pages/LobbySummary";

interface Props {
  lobby: Lobby;
}

const FullSummary: React.FC<Props> = ({ lobby }) => {
  const [presentSummary, dismissSummary] = useIonModal(LobbySummary, {
    lobby: lobby,
    onDismiss: () => dismissSummary()
  });
  return (
    <>
      <IonButton
        color="primary"
        className="rounded w-full h-12 font-semibold"
        onClick={() => presentSummary()}
      >
        Full Summary
      </IonButton>
    </>
  );
};

export default FullSummary;
